<div class="uk-height-1-1">
  @if (showNavigation()) {
    <tess-navigation />
  }

  <router-outlet />
</div>
